export default __webpack_public_path__ + "static/media/home-4.945cff0e.png";